/* @flow */
import React from "react";
import { Route, Switch } from "react-router";
import AppMeta from "./AppMeta";
import { CBDView, Errors } from "../components";
import DecommissionBanner from "../components/DecommissionBanner/DecommissionBanner";

class App extends React.Component<{}> {
  render() {
    return (
      <div>
        <div>
          <AppMeta />
          <DecommissionBanner />
          <Switch>
            <Route path="/cbd" component={CBDView} />
            <Route component={Errors} />
          </Switch>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js